<div class="flex flex-col p-4">
  <div class="rounded-xl p-4 bg-white flex flex-col gap-4 items-center" role="main">
    <app-loading [isLoading]="true" [single]="true" class="-my-4"></app-loading>
    <h1 class="text-4xl" role="status" aria-live="polite">Herzlichen Glückwunsch!</h1>
    <p class="text-xl font-semibold">Ihre Reservierung wurde übermittelt!</p>
    <p class="text-center">Eine Kopie Ihrer Reservierungsanfrage wurde an Ihre E-Mail gesendet. Nach Bearbeitung Ihrer Anfrage werden wir Ihre Reservierung bestätigen und eine Rechnung zusenden. Eine Zahlung ist derzeit nicht notwendig.</p>
    <a href="https://www.beimbenz.de/" 
       class="px-8 py-4 bg-benzRed-700 text-white rounded-lg uppercase w-full text-center focus:outline-none focus:ring-2 focus:ring-benzRed-700 focus:ring-offset-2"
       aria-label="Zurück zur Startseite von Beim BENZ">
      Zurück zur Startseite
    </a>
  </div>
</div>
